(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amalfi-editorial-story"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.getElementById('AmalfiStory-{{ section.id }}');
    if (!root) return;

    var reveals = root.querySelectorAll('.amalfi-reveal');
    if (!reveals.length) return;

    root.classList.add('is-reveal-ready');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('amalfi-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      reveals.forEach(function(el) {
        observer.observe(el);
      });
    } else {
      reveals.forEach(function(el) {
        el.classList.add('amalfi-reveal--visible');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amalfi-feature-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.getElementById('AmalfiFeatures-{{ section.id }}');
    if (!root) return;

    var reveals = root.querySelectorAll('.amalfi-reveal');
    if (!reveals.length) return;

    root.classList.add('is-reveal-ready');

    if ('IntersectionObserver' in window) {
      var revealCount = 0;
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var delay = revealCount * 150;
            revealCount++;
            setTimeout(function() {
              entry.target.classList.add('amalfi-reveal--visible');
            }, delay);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      reveals.forEach(function(el) {
        observer.observe(el);
      });
    } else {
      reveals.forEach(function(el) {
        el.classList.add('amalfi-reveal--visible');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amalfi-product-passport"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.getElementById('AmalfiPassport-{{ section.id }}');
    if (!root) return;

    var reveals = root.querySelectorAll('.amalfi-reveal');
    if (!reveals.length) return;

    root.classList.add('is-reveal-ready');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('amalfi-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      reveals.forEach(function(el) {
        observer.observe(el);
      });
    } else {
      reveals.forEach(function(el) {
        el.classList.add('amalfi-reveal--visible');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-content-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll(
      '.ecp__richtext, .ecp__features, .ecp__steps, .ecp__timeline, .ecp__stats, .ecp__related, .ecp__full-image, .ecp__cta'
    );
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function(el) { el.classList.add('ecp--visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ecp--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    sections.forEach(function(el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-cotton-guide"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll(
      '.ecg__chapter, .ecg__features, .ecg__products, .ecg__info-cards, .ecg__full-image, .ecg__cta'
    );
    if (!sections.length) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ecg--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    sections.forEach(function(el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
 class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  //class ProductRecommendations2 extends HTMLElement {
  //  constructor() {
  //    super();

  //    const handleIntersection = (entries, observer) => {
  //      if (!entries[0].isIntersecting) return;
  //      observer.unobserve(this);

  //      fetch(this.dataset.url)
  //        .then((response) => response.text())
  //        .then((text) => {
  //          const html = document.createElement('div');
  //          html.innerHTML = text;
  //          const recommendations = html.querySelector('product-recommendations2');
  //          if (recommendations && recommendations.innerHTML.trim().length) {
  //            this.innerHTML = recommendations.innerHTML;
  //          }
  //        })
  //        .catch((e) => {
  //          console.error(e);
  //        });
  //    };

  //    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
  //  }
  //}

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);
  //customElements.define('product-recommendations2', ProductRecommendations2);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
	constructor() {
	super();
}

connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.header1 = document.querySelector('.header-wrapper--under-menu')
	this.header_wrapper = document.querySelector('.header-wrapper');
	this.header__offcanvas_menu = document.querySelector('.header__offcanvas-menu');
	this.predictiveSearch = this.querySelector('predictive-search');
	this.headerBounds = {};
	this.currentScrollTop = 0;

	this.onScrollHandler = this.onScroll.bind(this);

	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
}

disconnectedCallback() {
	window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
});

	observer.observe(this.header);
}

onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
		this.predictiveSearch.onFocusOut();
		this.predictiveSearch.onBlur();
	} 
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
	} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
}

	hide() {
		document.dispatchEvent(new CustomEvent('ho:close-panels'));
		if(this.header1){
			this.header.classList.add('shopify-section-header-fixed-hidden', 'shopify-section-header-sticky', 'animate');
		}
		else {
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
		}
	// this.closeSearchModal();
}

reveal() {
	if(this.header1){
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-fixed-hidden');
			this.header_wrapper.classList.add('header-wrapper--under-menu-full');
		}
	else {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
	}
	if (this.header__offcanvas_menu) this.header__offcanvas_menu.classList.add('header__offcanvas_menu-reveal')
}

reset() {
	if(this.header1){
		this.header.classList.remove('shopify-section-header-fixed-hidden', 'shopify-section-header-sticky', 'animate');
		this.header_wrapper.classList.remove('header-wrapper--under-menu-full');
	}
	else {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}
	if (this.header__offcanvas_menu) this.header__offcanvas_menu.classList.remove('header__offcanvas_menu-reveal')

}

closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure?.close());
}

// closeSearchModal() {
// 	this.searchModal = this.searchModal || this.header.querySelector('details-modal');
// 	this.searchModal.close(false);
// }
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcy-collection-editorial"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll(
      '.lce__chapter, .lce__features, .lce__steps-section, .lce__summary, .lce__products, .lce__related, .lce__faq, .lce__full-image, .lce__cta'
    );
    if (!sections.length) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lce--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    sections.forEach(function(el) { observer.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcy-heritage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    var rows = document.querySelectorAll('[data-heritage-row]');

    rows.forEach(function (row) {
      var isEven = row.getAttribute('data-row-even') === '0';
      var media = row.querySelector('[data-heritage-media]');
      var content = row.querySelector('[data-heritage-content]');

      if (media) {
        gsap.from(media, {
          x: isEven ? 60 : -60,
          opacity: 0,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: row,
            start: 'top 80%',
            once: true,
          },
        });
      }

      if (content) {
        gsap.from(content, {
          y: 40,
          opacity: 0,
          duration: 0.8,
          delay: 0.2,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: row,
            start: 'top 80%',
            once: true,
          },
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcy-lookbook"] && !Shopify.designMode) return;
  try {
    
  /* GSAP ScrollTrigger — fade-in-up stagger for lookbook items.
     GSAP + ScrollTrigger are loaded globally via theme.liquid. */

  (function () {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('[id^="LcyLookbook-"]').forEach(function (section) {
      var items = section.querySelectorAll('.lcy-lookbook__item');
      if (!items.length) return;

      /* Respect reduced-motion preference */
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      gsap.set(items, { opacity: 0, y: 40 });

      gsap.to(items, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.15,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: section,
          start: 'top 85%',
          once: true
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcy-split-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('.lcy-split-hero').forEach(function (section) {
      var img = section.querySelector('.lcy-split-hero__img');
      var blocks = section.querySelectorAll('.lcy-split-hero__content-inner > *');

      if (img) {
        gsap.from(img, {
          scale: 1.05,
          duration: 1.2,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: section,
            start: 'top 85%',
            once: true,
          },
        });
      }

      if (blocks.length) {
        gsap.from(blocks, {
          y: 30,
          opacity: 0,
          duration: 0.8,
          ease: 'power2.out',
          stagger: 0.15,
          scrollTrigger: {
            trigger: section,
            start: 'top 75%',
            once: true,
          },
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcy-statement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    var sections = document.querySelectorAll('.lcy-statement');

    sections.forEach(function (section) {
      var elements = section.querySelectorAll('[data-statement-animate]');
      if (!elements.length) return;

      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced) {
        elements.forEach(function (el) {
          el.style.opacity = '1';
        });
        return;
      }

      gsap.set(elements, { opacity: 0, y: 30 });

      ScrollTrigger.create({
        trigger: section,
        start: 'top 80%',
        once: true,
        onEnter: function () {
          gsap.to(elements, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
            stagger: 0.2,
          });
        },
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcy-video-split"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---- Play / Pause toggle ---- */
    document.querySelectorAll('[data-section-type="video-split"]').forEach(function (section) {
      var videoEl = section.querySelector('video[data-vs-video]');
      var toggleBtn = section.querySelector('[data-vs-play-toggle]');
      var iconPlay = section.querySelector('[data-vs-icon-play]');
      var iconPause = section.querySelector('[data-vs-icon-pause]');
      var isPlaying = true;

      function updateToggleUI(playing) {
        if (!toggleBtn || !iconPlay || !iconPause) return;
        isPlaying = playing;
        iconPlay.style.display = playing ? 'none' : '';
        iconPause.style.display = playing ? '' : 'none';
        toggleBtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }

      if (toggleBtn && videoEl) {
        toggleBtn.addEventListener('click', function () {
          if (isPlaying) {
            videoEl.pause();
            updateToggleUI(false);
          } else {
            videoEl.play();
            updateToggleUI(true);
          }
        });
      }

      /* ---- IntersectionObserver: pause when out of viewport ---- */
      if (videoEl && typeof IntersectionObserver !== 'undefined') {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                if (!isPlaying) return;
                videoEl.play().catch(function () {});
              } else {
                videoEl.pause();
              }
            });
          },
          { threshold: 0.15 }
        );
        observer.observe(section);
      }

      /* ---- GSAP ScrollTrigger animations ---- */
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

      gsap.registerPlugin(ScrollTrigger);

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) return;

      /* Text blocks: staggered reveal */
      var blocks = section.querySelectorAll('[data-vs-block]');
      if (blocks.length) {
        gsap.from(blocks, {
          y: 30,
          opacity: 0,
          duration: 0.8,
          stagger: 0.15,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: section.querySelector('[data-vs-content]'),
            start: 'top 80%',
            once: true,
          },
        });
      }

      /* Video side: subtle scale on scroll */
      var mediaEl = section.querySelector('[data-vs-media]');
      if (mediaEl) {
        gsap.fromTo(
          mediaEl,
          { scale: 1.05 },
          {
            scale: 1,
            ease: 'none',
            scrollTrigger: {
              trigger: mediaEl,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 0.6,
            },
          }
        );
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lcy-video-statement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* --- Play / Pause toggle --- */
    var sections = document.querySelectorAll('.lcy-vs');

    sections.forEach(function (section) {
      var video = section.querySelector('video.lcy-vs__video');
      var toggle = section.querySelector('.lcy-vs__toggle');

      /* Mark as loaded once video can play */
      if (video) {
        var markLoaded = function () {
          section.classList.add('video-loaded');
          video.removeEventListener('canplay', markLoaded);
        };
        if (video.readyState >= 3) {
          section.classList.add('video-loaded');
        } else {
          video.addEventListener('canplay', markLoaded);
        }
      }

      /* Toggle play/pause */
      if (toggle && video) {
        toggle.addEventListener('click', function () {
          var isPlaying = toggle.getAttribute('data-playing') === 'true';
          if (isPlaying) {
            video.pause();
            toggle.setAttribute('data-playing', 'false');
            toggle.setAttribute('aria-label', 'Play video');
          } else {
            video.play();
            toggle.setAttribute('data-playing', 'true');
            toggle.setAttribute('aria-label', 'Pause video');
          }
        });
      }

      /* IntersectionObserver — pause when out of viewport, resume when visible */
      if (video && 'IntersectionObserver' in window) {
        var autoplay = section.getAttribute('data-autoplay') === 'true';
        var wasPausedByUser = false;

        if (toggle) {
          toggle.addEventListener('click', function () {
            wasPausedByUser = toggle.getAttribute('data-playing') === 'false';
          });
        }

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                if (autoplay && !wasPausedByUser) {
                  video.play().catch(function () {});
                  if (toggle) toggle.setAttribute('data-playing', 'true');
                }
              } else {
                if (!video.paused) {
                  video.pause();
                  if (toggle) toggle.setAttribute('data-playing', 'false');
                }
              }
            });
          },
          { threshold: 0.25 }
        );

        observer.observe(section);
      }
    });

    /* --- GSAP text animation --- */
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    sections.forEach(function (section) {
      var elements = section.querySelectorAll('[data-vs-animate]');
      if (!elements.length) return;

      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced) {
        elements.forEach(function (el) {
          el.style.opacity = '1';
        });
        return;
      }

      gsap.set(elements, { opacity: 0, y: 30 });

      ScrollTrigger.create({
        trigger: section,
        start: 'top 80%',
        once: true,
        onEnter: function () {
          gsap.to(elements, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
            stagger: 0.2,
          });
        },
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function initProductComponents() {
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.slides = [];
        this.currentIndex = 0;

        this.prevBtn = this.querySelector('.product-media-modal__nav--prev');
        this.nextBtn = this.querySelector('.product-media-modal__nav--next');
        this.counterCurrent = this.querySelector('.product-media-modal__counter-current');
        this.counterTotal = this.querySelector('.product-media-modal__counter-total');
        this.overlay = this.querySelector('.product-media-modal__overlay');
        this.content = this.querySelector('.product-media-modal__content');

        // Stop pointerup on dialog so base ModalDialog's media-modal handler
        // doesn't close the modal when clicking arrows, images, or controls
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (dialog) dialog.addEventListener('pointerup', (e) => e.stopPropagation());

        if (this.prevBtn) this.prevBtn.addEventListener('click', (e) => { e.stopPropagation(); this.navigate(-1); });
        if (this.nextBtn) this.nextBtn.addEventListener('click', (e) => { e.stopPropagation(); this.navigate(1); });
        if (this.overlay) this.overlay.addEventListener('click', () => this.hide());

        if (this.content) {
          this.touchStartX = 0;
          this.touchStartY = 0;
          this.content.addEventListener('touchstart', (e) => {
            this.touchStartX = e.changedTouches[0].screenX;
            this.touchStartY = e.changedTouches[0].screenY;
          }, { passive: true });
          this.content.addEventListener('touchend', (e) => {
            const zoomed = this.content.querySelector('.product-media-modal__slide.is-zoomed');
            if (zoomed || (window.visualViewport && window.visualViewport.scale > 1)) return;
            const diffX = e.changedTouches[0].screenX - this.touchStartX;
            const diffY = e.changedTouches[0].screenY - this.touchStartY;
            if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
              this.navigate(diffX > 0 ? -1 : 1);
            }
          }, { passive: true });
        }
      }

      show(opener) {
        this.slides = Array.from(this.querySelectorAll('.product-media-modal__slide'));
        super.show(opener);
        this.showActiveMedia();
        this._keyHandler = this.handleKeydown.bind(this);
        document.addEventListener('keydown', this._keyHandler);
      }

      hide() {
        if (this._keyHandler) document.removeEventListener('keydown', this._keyHandler);
        super.hide();
        window.pauseAllMedia();
      }

      handleKeydown(e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.navigate(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.navigate(1); }
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        let targetIndex = 0;
        this.slides.forEach((slide, i) => {
          slide.classList.remove('active');
          if (slide.getAttribute('data-media-id') === mediaId) targetIndex = i;
        });
        this.goToSlide(targetIndex);
      }

      navigate(dir) {
        let idx = this.currentIndex + dir;
        if (idx < 0) idx = this.slides.length - 1;
        if (idx >= this.slides.length) idx = 0;
        window.pauseAllMedia();
        this.goToSlide(idx);
      }

      goToSlide(index) {
        this.slides.forEach(s => s.classList.remove('active'));
        this.currentIndex = index;
        this.slides[index].classList.add('active');
        if (this.counterCurrent) this.counterCurrent.textContent = index + 1;
        if (this.counterTotal) this.counterTotal.textContent = this.slides.length;

        const deferred = this.slides[index].querySelector('deferred-media');
        if (deferred && deferred.querySelector('template')?.content?.querySelector('.js-youtube'))
          deferred.loadContent();

        const next = (index + 1) % this.slides.length;
        const prev = (index - 1 + this.slides.length) % this.slides.length;
        [next, prev].forEach(i => {
          const img = this.slides[i]?.querySelector('.product-media-modal__image');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        });
      }
    }

    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
              if (!this.querySelector('.ho-bw__card')) this.classList.add('ho-bw-empty');
            })
            .catch((e) => {
              console.error(e);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
      }
    }

    customElements.define('product-modal', ProductModal);
    customElements.define('product-recommendations', ProductRecommendations);
  }

  class ProductHoverZoom {
    constructor() {
      if (window.matchMedia('(pointer: coarse)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (window.innerWidth < 990) return;
      this.slider = document.querySelector('.product-section .js-media-list');
      if (!this.slider) return;

      this.zoomOverlay = document.createElement('div');
      this.zoomOverlay.className = 'product-zoom-overlay';
      this.zoomOverlay.setAttribute('aria-hidden', 'true');
      this.isZooming = false;
      this.currentContainer = null;
      this.loadedUrls = new Set();

      this.slider.addEventListener('mouseenter', this.onEnter.bind(this), true);
      this.slider.addEventListener('mousemove', this.onMove.bind(this));
      this.slider.addEventListener('mouseleave', this.onLeave.bind(this));

      if (this.slider.swiper) {
        this.slider.swiper.on('slideChangeTransitionStart', () => this.deactivate());
      }

      requestIdleCallback(() => {
        const firstSlide = this.slider.querySelector('.swiper-slide-active, .swiper-slide:first-child');
        if (!firstSlide) return;
        const opener = firstSlide.querySelector('modal-opener[data-zoom-url]');
        if (!opener) return;
        const url = opener.getAttribute('data-zoom-url');
        const img = new Image();
        img.onload = () => this.loadedUrls.add(url);
        img.src = url;
      }, { timeout: 2000 });
    }

    onEnter(e) {
      const slide = e.target.closest('.swiper-slide-active, .swiper-slide');
      if (!slide || !slide.classList.contains('swiper-slide-active')) return;
      const opener = slide.querySelector('modal-opener[data-zoom-url]');
      if (!opener) return;
      const media = opener.querySelector('.product__media');
      if (!media) return;

      const url = opener.getAttribute('data-zoom-url');
      if (!media.contains(this.zoomOverlay)) media.appendChild(this.zoomOverlay);
      this.zoomOverlay.style.backgroundImage = `url("${url}")`;

      if (this.loadedUrls.has(url)) {
        this.activate(media);
      } else {
        const img = new Image();
        img.onload = () => { this.loadedUrls.add(url); this.activate(media); };
        img.src = url;
      }
    }

    activate(container) {
      this.isZooming = true;
      this.currentContainer = container;
      const slide = container.closest('.swiper-slide');
      const fp = slide ? getComputedStyle(slide).getPropertyValue('--ho-fp').trim() : '';
      this.zoomOverlay.style.backgroundSize = 'cover';
      this.zoomOverlay.style.backgroundPosition = fp || '50% 30%';
      this.zoomOverlay.style.transformOrigin = '50% 30%';
      this.zoomOverlay.style.transform = 'scale(1)';
      this.zoomOverlay.classList.add('active');
    }

    onMove(e) {
      if (!this.isZooming || !this.currentContainer) return;
      const rect = this.currentContainer.getBoundingClientRect();
      const x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
      this.zoomOverlay.style.transformOrigin = `${x}% ${y}%`;
      this.zoomOverlay.style.transform = 'scale(2)';
    }

    onLeave() { this.deactivate(); }

    deactivate() {
      if (!this.isZooming) return;
      this.isZooming = false;
      this.zoomOverlay.style.transform = 'scale(1)';
      this.zoomOverlay.classList.remove('active');
    }
  }

  /* Wait for ModalDialog (from global.js defer) before defining ProductModal */
  if (!customElements.get('product-modal')) {
    if (customElements.get('modal-dialog')) {
      initProductComponents();
    } else {
      customElements.whenDefined('modal-dialog').then(initProductComponents);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductHoverZoom());
  } else {
    new ProductHoverZoom();
  }

  /* Heritage Olive: show the chosen colour's name beside the "Colour" label (variant-radios fires change on pick) */
  if (!window.__hoOptionValueBound) {
    window.__hoOptionValueBound = true;
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!input || input.type !== 'radio') return;
      const fieldset = input.closest('.product-form__input--radios');
      const output = fieldset && fieldset.querySelector('[data-ho-option-value]');
      if (output) output.textContent = input.value;
    });
  }

  /* Heritage Olive: sticky add-to-bag dock bar (markup in snippets/heritage-sticky-atc.liquid, styles in assets/heritage-product.css) */
  if (!customElements.get('heritage-sticky-atc')) {
    class HeritageStickyAtc extends HTMLElement {
      connectedCallback() {
        // Never inside a quick-add or quick-view modal.
        if (this.closest('quick-add-modal, quick-view-modal')) return;

        this.target = document.getElementById(this.dataset.trigger);
        this.button = this.querySelector('[data-ho-sticky-button]');
        this.label = this.querySelector('[data-ho-sticky-label]');
        this.priceOut = this.querySelector('[data-ho-sticky-price]');
        this.thumb = this.querySelector('[data-ho-sticky-thumb]');
        if (!this.target || !this.button) return;

        this.mirror();
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        if (this.mobileQuery.matches) this.toggle(true);

        // Show whenever the main button is not intersecting the viewport, above or below.
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              const entry = entries[entries.length - 1];
              this.toggle(this.mobileQuery.matches || !entry.isIntersecting);
            },
            { threshold: 0 }
          );
          this.observer.observe(this.target);
        }

        // Label ("Add to bag", "Sold out", "Added to bag"), disabled and loading state follow the main button.
        this.targetObserver = new MutationObserver(() => this.mirror());
        this.targetObserver.observe(this.target, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        // Price follows the block the theme re-renders after a variant change.
        this.priceBlock = document.getElementById(this.dataset.price);
        if (this.priceBlock) {
          this.priceObserver = new MutationObserver(() => this.syncPrice());
          this.priceObserver.observe(this.priceBlock, { childList: true, subtree: true, characterData: true });
          this.syncPrice();
        }

        this.onVariant = this.onVariant.bind(this);
        document.addEventListener('variant:change', this.onVariant);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.targetObserver) this.targetObserver.disconnect();
        if (this.priceObserver) this.priceObserver.disconnect();
        if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
        document.documentElement.classList.remove('ho-sticky-on');
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        if (show) {
          this.removeAttribute('inert');
        } else {
          this.setAttribute('inert', '');
        }
        document.documentElement.classList.toggle('ho-sticky-on', show);
      }

      mirror() {
        const source = this.target;
        const sourceLabel = source.querySelector('.product-form__label');
        if (sourceLabel && this.label && this.label.textContent !== sourceLabel.textContent) {
          this.label.textContent = sourceLabel.textContent;
        }
        this.button.disabled = source.hasAttribute('disabled');
        if (source.getAttribute('aria-disabled') === 'true') {
          this.button.setAttribute('aria-disabled', 'true');
        } else {
          this.button.removeAttribute('aria-disabled');
        }
        this.button.classList.toggle('loading', source.classList.contains('loading'));
      }

      syncPrice() {
        if (!this.priceOut || !this.priceBlock) return;
        const sale = this.priceBlock.querySelector('.price--on-sale .price-item--sale');
        const regular = this.priceBlock.querySelector('.price__regular .price-item--regular');
        const node = sale || regular;
        if (!node || !node.textContent.trim()) return;
        const text = node.textContent.trim();
        this.priceOut.textContent = text;
        document.querySelectorAll('[data-ho-mobile-price]').forEach((price) => {
          price.textContent = text;
        });
      }

      onVariant(event) {
        const detail = event.detail || {};
        if (detail.sectionId !== this.dataset.source || !detail.variant) return;
        const media = detail.variant.featured_media;
        const src = media && media.preview_image && media.preview_image.src;
        if (this.thumb && src) {
          try {
            const url = new URL(src, window.location.origin);
            url.searchParams.set('width', '80');
            url.searchParams.set('height', '80');
            url.searchParams.set('crop', 'center');
            this.thumb.src = url.toString();
            this.thumb.removeAttribute('srcset');
          } catch (error) {
            /* keep the current thumbnail */
          }
        }
      }
    }

    customElements.define('heritage-sticky-atc', HeritageStickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
	class ProductRecommendations2 extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations2'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	if (!customElements.get('product-recommendations2')) {
		customElements.define('product-recommendations2', ProductRecommendations2);
	}

  } catch(e) { console.error(e); }
})();
})();
